<template>
<div>
  <custom-loader v-if="loadingProgramsData" />
  <div v-else >
    <div :style="programsMainData.semester_programs_title.content_background_color ? getDynamicPageBg(programsMainData.semester_programs_title) : ''" class="py-3">
      <div class="container">
        <div class="d-flex justify-content-end">
          <li class="breadcrumb text-align-right">
            <span class="breadcrumb-item"><a href="/">Home</a></span>
            <span class="breadcrumb-item active">Programs</span>
          </li>
        </div>
      </div>
    </div>

    <scientific-activities-custom-static-content
      :title="programType === 'past' ? programsMainData.past_semester_programs_title : programsMainData.semester_programs_title"
      :photos="programType === 'past' ? programsMainData.past_semester_programs_photo.value : programsMainData.semester_programs_photo.value"
      :description="programType === 'past' ? programsMainData.past_semester_programs_text.value : programsMainData.semester_programs_text.value"
      :apply-button-label="programType === 'past' ? programsMainData.past_semester_programs_button_text.value : programsMainData.semester_programs_button_text.value"
      :apply-button-path="programType === 'past' ? programsMainData.past_semester_programs_button_link.value : programsMainData.semester_programs_button_link.value"
      :edit-cms-route="programType === 'past' ? 'past-semester-programs-edit' : 'programs-edit'"
      :menu-id="menuId"
    />
    <custom-dynamic-static-content-page :new-contents="newContents"/>
  </div>
  <div id="program-tab-id">
    <div class="container pt-tab-bg">
      <div class="custom-tab">
        <b-tabs card lazy>
          <b-tab
            title="Current and Upcoming Programs"
            v-if="this.programType !== 'past'"
            @click.prevent="setCurrentTab('current_upcoming_programs', 'program-tab-id')"
            :active="getActiveTab === 'current_upcoming_programs'"
          >
            <current-and-upcoming-program-tab
              :program-type="programType"
              :menu-id="menuId"
            />
          </b-tab>
          <b-tab
            title="Past Programs"
            @click.prevent="setCurrentTab('past_programs', 'program-tab-id')"
            :active="getActiveTab === 'past_programs'"
          >
            <past-program-tab
              :program-type="programType"
              :menu-id="menuId"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import CurrentAndUpcomingProgramTab from './CurrentAndUpcomingProgramTab.vue'
import PastProgramTab from './PastProgramTab.vue'
import CustomLoader from '@/components/CommonPages/CustomLoader.vue'
import { mapGetters } from 'vuex'
import mixin from '@/utils/mixin.js'
import CustomDynamicStaticContentPage from '@/components/Dynamic/CustomDynamicStaticContentPage.vue'
import ScientificActivitiesCustomStaticContent from '@/components/Dynamic/ScientificActivitiesCustomStaticContent.vue'

export default {
  name: 'SemesterPrograms',
  components: { CurrentAndUpcomingProgramTab, PastProgramTab, CustomLoader, CustomDynamicStaticContentPage, ScientificActivitiesCustomStaticContent },
  props: ['programType'],
  data () {
    return {
      programsMainData: {},
      loadingProgramsData: true,
      tabs: ['#current_upcoming_programs', '#past_programs'],
      newContents: [],
      menuId: '',
    }
  },
  mixins: [mixin],
  mounted() {
    if(this.tabs.indexOf(this.$route.hash) !== -1) {
      var hashPath = this.$route.hash
      this.setCurrentTab(hashPath.substring(1), 'program-tab-id')
    }
  },
  computed: {
    ...mapGetters(['getActiveTab'])
  },
  created () {
    this.loadProgramsData()
  },
  methods: {
    loadProgramsData () {
      this.$http.get(process.env.VUE_APP_API_URL + `/msri_menus/show_page_contents`, {
        params: {
          menu_path: this.$route.path
        }
      })
      .then((res) => {
        if(Object.keys(res.data).length !== 0) {
          var result = {};
          res.data.results.forEach((prop,index) => {
            result[prop.field_name] = prop;
          });
          this.programsMainData = result
          this.menuId = res.data.id
          this.newContents = res.data.new_contents
          this.loadingProgramsData = false
        } else {
          this.$toasted.global.error('There are no details available for this page. Please check back.')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.boxThis {
  position: -webkit-sticky; /* Safari */
  position: fixed;
  z-index: 99;
  border: 1px solid #666;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  padding: 3px;
  background-color: #FCFAF8;
}
</style>
